import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core'
import { some } from 'lodash'
import { SeDialogButton } from './dialog-types'

@Component({
  standalone: false,
  selector: 'se-dialog-footer',
  templateUrl: './dialog-footer.component.html',
})
export class SeDialogFooterComponent {

  private spinning: SeDialogButton
  private spinningTimer: number
  private spinnerDelay: number = 100

  @HostBinding('class.se-dialog__footer') baseClass: boolean = true
  @Input('se-data-buttons') public seDataButtons: SeDialogButton[]
  @Output('se-data-action') public seDataAction: EventEmitter<any> = new EventEmitter()

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    // noop
  }

  public reset(): void {
    this.spinning = undefined
    this.cancelSpinner()
  }

  public cancelSpinner(): void {
    window.clearTimeout(this.spinningTimer)
  }

  public async doAction(button: SeDialogButton): Promise<void> {
    this.delaySpinner(button)
    this.seDataAction.emit(button.action())
  }

  private delaySpinner(button: SeDialogButton): void {
    this.spinningTimer = window.setTimeout(() => {
      this.spinning = button
      this.changeDetectorRef.detectChanges()
    }, this.spinnerDelay)
  }

  public className(button: SeDialogButton): string {
    let className = button.className
    if (this.spinning === button) className += ' se-dialog-button--spinning'
    return className
  }

  public get groupClassName(): string {
    const baseClass = 'se-dialog-button-group'
    const flat = some(this.seDataButtons, btn => btn.className.includes('secondary'))
    return flat ? `${baseClass} ${baseClass}--flat` : baseClass
  }

}
